import { useState, useEffect } from "react";
import axios from "axios";
import { message, Switch as AntSwitch, ConfigProvider } from "antd";

import {
  Box,
  Button,
  Snackbar,
  Drawer,
  Typography,
  Tabs,
  Tab,
  IconButton,
  Modal,
  Link,
  Switch,
  CircularProgress,
  Menu,
  MenuItem,
  Select,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Popover,
  Stack,
  Paper,
  Chip,
  ListItemText,
  ListItem,
  List,
} from "@mui/material";

import {
  AccessTime as AccessTimeIcon,
  FontDownload as FontDownloadIcon,
  LocationOn as LocationOnIcon,
  Language as LanguageIcon,
  Map as MapIcon,
  Videocam as VideocamIcon,
  Phone as PhoneIcon,
  Markunread as MarkunreadIcon,
  CalendarMonth as CalendarMonthIcon,
  Security as SecurityIcon,
  LocalOffer as LocalOfferIcon,
  Close as CloseIcon,
  Calculate as CalculateIcon,
  Stars as StarsIcon,
  Add as AddIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
  Save as SaveIcon,
  InfoOutlined as InfoOutlinedIcon,
  DeleteOutline as DeleteOutlineIcon,
  ApartmentOutlined as ApartmentOutlinedIcon,
  NumbersOutlined as NumbersOutlinedIcon,
  LabelOutlined as LabelOutlinedIcon,
  CalendarTodayOutlined as CalendarTodayOutlinedIcon,
  ChangeHistory as ChangeHistoryIcon,
  Home as HomeIcon,
  EmailRounded,
  OpenWith,
  SentimentVerySatisfied,
  Favorite,
} from "@mui/icons-material";

import BedIcon from "@mui/icons-material/Bed";
import BathtubIcon from "@mui/icons-material/Bathtub";

import {
  DataGridPro,
  GridActionsCellItem,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
} from "@mui/x-data-grid-pro";

import realPageLogo from "../../images/realpage-logo.png";
import useStore from "../../store/store";
import TabProperties from "../tabs/tabs";
import ProrationCalculator from "../prorationCalculator";
import SpecialCalculator from "../SpecialCalculator";
import useAxiosInstance from "../../helpers/useAxiosInstance";

import "./table.css";
import { useAuth } from "../../context/AuthProvider";
import { PermissionWrapper } from "../AccessWrapper";
import { PERMISSIONS } from "../../constants/access.constant";
import { hasAllPermissions } from "../../helpers/accessHelper";

const bedroomFields = [
  { key: "studio", label: "Studio", priceKey: "studio_price" },
  { key: "one_bed", label: "1 Bed", priceKey: "one_bed_price" },
  { key: "two_bed", label: "2 Bed", priceKey: "two_bed_price" },
  { key: "three_bed", label: "3 Bed", priceKey: "three_bed_price" },
  { key: "four_plus_bed", label: "4+ Bed", priceKey: "four_plus_bed_price" },
];

const amenityFields = [
  { key: "one_and_a_half_bath", label: "1.5 bath" },
  { key: "concierge", label: "Concierge" },
  { key: "concrete_floors", label: "Floors" },
  { key: "desk", label: "Desk" },
  { key: "ev_charger", label: "EV Charger" },
  { key: "fireplace", label: "Fireplace" },
  { key: "floor_to_ceiling_windows", label: "Floor to ceiling windows" },
  // { key: "furnished", label: "Furnished" },
  { key: "garage", label: "Garage" },
  { key: "high_ceilings", label: "High ceilings" },
  { key: "industrial", label: "Industrial" },
  { key: "loft", label: "Loft" },
  { key: "no_carpet", label: "No carpet" },
  { key: "roof_terrace", label: "Roof terrace" },
  { key: "single_family", label: "Townhome/Single Family" },
  { key: "smart", label: "Smart" },
  { key: "study", label: "Study" },
  { key: "terrace", label: "Terrace" },
  // { key: "townhome", label: "Townhome" },
  { key: "tub_shower", label: "Tub + shower" },
  // { key: "washer_dryer_connections", label: "W/D connections" },
  // { key: "washer_dryer_in_building", label: "W/D in building" },
  // { key: "washer_dryer_in_unit", label: "W/D in unit" },
  { key: "yard", label: "Yard" },
];

const customWidthColumns = [
  "state",
  "id",
  "zip_code",
  "market",
  "studio_price",
  "one_bed_price",
  "two_bed_price",
  "three_bed_price",
  "four_plus_bed_price",
  // "admin_fee",
  // "application_fee",
  // "number_floors",
  "single_family",
  // "townhome",
  // "send",
  // "escort",
  // "bonus",
  "year_built",
  "year_renovated",
  "high_rise",
  "studio",
  "one_bed",
  "two_bed",
  "three_bed",
  "four_plus_bed",
  "yard",
  "garage",
  "loft",
  "study",
  "desk",
  "ev_charger",
  "fireplace",
  "no_carpet",
  "tub_shower",
  "industrial",
  "concrete_floors",
  // "furnished",
  "high_ceilings",
  "terrace",
  "roof_terrace",
  "floor_to_ceiling_windows",
  "concierge",
  "one_and_a_half_bath",
];

const antDTheme = {
  token: {
    colorPrimary: "#07bc0c",
  },
  components: {
    Switch: {
      colorPrimary: "#07bc0c",
      colorPrimaryHover: "#07bc0c",
      trackHeight: 20,
      trackMinWidth: 32,
      colorBgContainerDisabled: "#e0e0e0",
    },
  },
};

function getType(value) {
  if (value === "percentage") {
    return "%";
  } else if (value === "dollar") {
    return "$";
  } else {
    return "";
  }
}

const EditSendField = ({
  params,
  selectedRows,
  setFilteredProperties,
  handleRowUpdate,
}) => {
  const { row } = params;
  let singleRowData = { ...row };

  const [send, setSend] = useState(row?.send);
  const [sendClick, setSendClick] = useState(0);
  const [sendType, setSendType] = useState(row?.send_type);

  const handleSendChange = (event) => {
    setSend(event?.target?.value);
  };

  const isHighlighted = selectedRows?.id === row?.id;

  const handleSendSave = () => {
    setSendClick(0);
    if (send === row?.send) return;

    singleRowData.send = send;
    setFilteredProperties((prev) => {
      const oldData = [...prev];
      const index = oldData.findIndex((x) => x?.id === params?.id);
      if (index > -1) {
        oldData[index] = {
          ...oldData[index],
          send: send,
        };
      }
      return oldData;
    });
    handleRowUpdate(singleRowData);
  };

  const handleSendTypeChange = (event) => {
    setSendType(event?.target?.value);
  };

  const handleSendTypeSave = () => {
    setSendClick(0);
    if (sendType === row?.send_type) return;

    singleRowData.send_type = sendType;
    setFilteredProperties((prev) => {
      const oldData = [...prev];
      const index = oldData.findIndex((x) => x?.id === params?.id);
      if (index > -1) {
        oldData[index] = {
          ...oldData[index],
          send_type: sendType,
        };
      }
      return oldData;
    });
    handleRowUpdate(singleRowData);
  };

  const handleSendEnter = (event) => {
    if (event.key === "Enter") {
      setSendClick(0);
      if (send === row?.send) return;

      singleRowData.send = send;
      setFilteredProperties((prev) => {
        const oldData = [...prev];
        const index = oldData.findIndex((x) => x?.id === params?.id);
        if (index > -1) {
          oldData[index] = {
            ...oldData[index],
            send: send,
          };
        }
        return oldData;
      });
      handleRowUpdate(singleRowData);
    }
  };

  const handleSendTypeEnter = (event) => {
    if (event.key === "Enter") {
      setSendClick(0);
      if (sendType === row.send_type) return;

      singleRowData.send_type = sendType;
      setFilteredProperties((prev) => {
        const oldData = [...prev];
        const index = oldData.findIndex((x) => x?.id === params?.id);
        if (index > -1) {
          oldData[index] = {
            ...oldData[index],
            send_type: sendType,
          };
        }
        return oldData;
      });
      handleRowUpdate(singleRowData);
    }
  };

  const type = getType(row?.send_type);

  let valueDisplay = null;
  if (send > 0) {
    if (type === "$") {
      valueDisplay = `${type}${send}`;
    } else {
      valueDisplay = `${send}${type}`;
    }
  }

  return (
    <div
      className={`group-hover/row:bg-neutral-100 ${
        isHighlighted ? "bg-cyan-800" : ""
      }`}
      style={{ display: "flex", flexDirection: "column", width: "100%" }}
      onClick={() => setSendClick((prev) => prev + 1)}
    >
      {sendClick > 1 ? (
        <>
          <div>
            <input
              type="number"
              value={send || ""}
              style={{ width: "100%" }}
              className="focus:outline-none border-0 group-hover/row:bg-neutral-100 w-[130px]"
              onChange={handleSendChange}
              onBlur={handleSendSave}
              onKeyDown={handleSendEnter}
              placeholder="-"
            />
          </div>
          <div>
            <select
              className="focus:outline-none border-1 w-[130px] group-hover/row:bg-neutral-100"
              style={{ width: "100%" }}
              value={sendType || "percentage"}
              onChange={handleSendTypeChange}
              onBlur={handleSendTypeSave}
              onKeyDown={handleSendTypeEnter}
            >
              <option value="percentage">%</option>
              <option value="dollar">$</option>
            </select>
          </div>
        </>
      ) : (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span style={{ height: "50px", paddingTop: "15px" }}>
            {valueDisplay}
          </span>
        </div>
      )}
    </div>
  );
};

const EditEscortField = ({
  params,
  selectedRows,
  setFilteredProperties,
  handleRowUpdate,
}) => {
  const { row } = params;
  let singleRowData = { ...row };

  const [escort, setEscort] = useState(row?.escort);
  const [escortType, setEscortType] = useState(row?.escort_type);
  const [clickCount, setClickCount] = useState(0);

  const handleEscortChange = (event) => {
    setEscort(event?.target?.value);
  };

  const isHighlighted = selectedRows?.id === row?.id;

  const handleEscortSave = () => {
    setClickCount(0);
    if (escort === row?.escort) return;

    singleRowData.escort = escort;
    setFilteredProperties((prev) => {
      const oldData = [...prev];
      const index = oldData.findIndex((x) => x?.id === params?.id);
      if (index > -1) {
        oldData[index] = {
          ...oldData[index],
          escort: escort,
        };
      }
      return oldData;
    });
    handleRowUpdate(singleRowData);
  };

  const handleEscortTypeChange = (event) => {
    setEscortType(event?.target?.value);
  };

  const handleEscortTypeSave = () => {
    setClickCount(0);
    if (escortType === row?.escort_type) return;

    singleRowData.escort_type = escortType;
    setFilteredProperties((prev) => {
      const oldData = [...prev];
      const index = oldData.findIndex((x) => x?.id === params?.id);
      if (index > -1) {
        oldData[index] = {
          ...oldData[index],
          escort_type: escortType,
        };
      }
      return oldData;
    });
    handleRowUpdate(singleRowData);
  };

  const handleEscortEnter = (event) => {
    if (event.key === "Enter") {
      setClickCount(0);
      if (escort === row?.escort) return;

      singleRowData.escort = escort;
      setFilteredProperties((prev) => {
        const oldData = [...prev];
        const index = oldData.findIndex((x) => x?.id === params?.id);
        if (index > -1) {
          oldData[index] = {
            ...oldData[index],
            escort: escort,
          };
        }
        return oldData;
      });
      handleRowUpdate(singleRowData);
    }
  };

  const handleEscortTypeEnter = (event) => {
    if (event.key === "Enter") {
      setClickCount(0);
      if (escortType === row.escort_type) return;

      singleRowData.escort_type = escortType;
      setFilteredProperties((prev) => {
        const oldData = [...prev];
        const index = oldData.findIndex((x) => x?.id === params?.id);
        if (index > -1) {
          oldData[index] = {
            ...oldData[index],
            escort_type: escortType,
          };
        }
        return oldData;
      });
      handleRowUpdate(singleRowData);
    }
  };

  const type = getType(row.escort_type);
  let valueDisplay = null;
  if (escort > 0) {
    if (type === "$") {
      valueDisplay = `${type}${escort}`;
    } else {
      valueDisplay = `${escort}${type}`;
    }
  }

  return (
    <div
      className={`group-hover/row:bg-neutral-100 ${
        isHighlighted ? "bg-cyan-800" : ""
      }`}
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        gap: 2,
      }}
      onClick={() => setClickCount((prev) => prev + 1)}
    >
      {clickCount > 1 ? (
        <>
          <div>
            <input
              type="number"
              value={escort || ""}
              className="focus:outline-none border-0 group-hover/row:bg-neutral-100 w-[130px]"
              onChange={handleEscortChange}
              onBlur={handleEscortSave}
              onKeyDown={handleEscortEnter}
              placeholder="-"
            />
          </div>
          <div>
            <select
              className="focus:outline-none border-1 w-[130px] group-hover/row:bg-neutral-100"
              value={escortType || "percentage"}
              onChange={handleEscortTypeChange}
              onBlur={handleEscortTypeSave}
              onKeyDown={handleEscortTypeEnter}
            >
              <option value="percentage">%</option>
              <option value="dollar">$</option>
            </select>
          </div>
        </>
      ) : (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span style={{ height: "50px", paddingTop: "15px" }}>
            {valueDisplay}
          </span>
        </div>
      )}
    </div>
  );
};

const AllProperties = ({
  properties,
  setFilteredProperties,
  paginationModel,
  setPaginationModel,
  totalRows,
  setSortModel,
  sortModel,
  fetchData,
  loading,
  refresh,
  driveData,
}) => {
  //const user = useStore((state) => state.user);
  const [messageApi, contextHolder] = message.useMessage();
  const axiosInstance = useAxiosInstance();

  const { user: authUser, isHydrated } = useAuth();
  const storeUser = useStore((state) => state.user);
  const user = authUser || storeUser;

  const [idArray, setIdArray] = useState([]);
  const [currentProperty, setCurrentProperty] = useState({});
  const [currentSelectedData, setCurrentSelectedData] = useState({});
  const [selectedCellData, setSelectedCellData] = useState(null);
  const [isPopupDoubleClickOpen, setIsDoubleClickPopupOpen] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const [bedCount, setBedCount] = useState({
    studio: 0,
    one_bed: 0,
    two_bed: 0,
    three_bed: 0,
    four_plus_bed: 0,
  });
  const [specialData, setSpecialData] = useState({});
  const [width, setWidth] = useState(true);
  const [termLengthProp, setTermLengthProp] = useState();
  const [monthFeeProp, setMonthFeeProp] = useState();
  const [monthFeePropReferenceProp, setMonthFeeReferenceProp] = useState();
  const [rentConcessionProp, setRentConcessionProp] = useState();
  const [rentConcessionReferenceProp, setRentConcessionReferenceProp] =
    useState();
  const [hideTab, setHideTab] = useState(true);
  const [modalLoader, setModalLoader] = useState(false);
  const [isSightMap, setIsSightMap] = useState(false);
  const [currentRowData, setCurrentRowData] = useState({});
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [currentId, setCurrentId] = useState({});
  const [currentUnit, setCurrentUnit] = useState([]);
  const [notAvailable, setNotAvailable] = useState(false);
  const [tempUnit, setTempUnit] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showCategory, setShowCategory] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [subMenuOpen, setSubMenuOpen] = useState(false);
  const [contextMenu, setContextMenu] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [emailSnackbarOpen, setEmailSnackbarOpen] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const [propertyId, setPropertyId] = useState(0);
  const [propertyDetails, setPropertyDetails] = useState({});
  const [currentRow, setCurrentRow] = useState({});
  const [data, setData] = useState("");
  const [localLink, setLocalLink] = useState({
    0: [],
    1: [],
    2: [],
    3: [],
    4: [],
  });
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [editId, setEditId] = useState();
  const [tours, setTours] = useState([]);
  const [calculator, setCalculator] = useState({ open: false, data: null });
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeRowId, setActiveRowId] = useState(null);
  const [allASpecials, setAllAspecials] = useState([]);
  const [openBedroomDialog, setOpenBedroomDialog] = useState(false);
  const [openAmenitiesDialog, setOpenAmenitiesDialog] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [exporting, setExporting] = useState(false);

  //------------------------------------------------------------------------------------------------------//
  useEffect(() => {
    const filteredProperties = properties.filter(
      (property) => property?.id === editId
    );
    const mappedTours = filteredProperties
      .map((property) => property?.virtual_tour)
      .flat();

    if (mappedTours?.length > 0 && mappedTours[0] !== null) {
      setTours(mappedTours);
    } else {
      setTours([{ name: "", link: "" }]);
    }
  }, [properties, editId, currentId]);

  useEffect(() => {
    if (selectedCategory) {
      let updatedCategory = selectedCategory;
      if (selectedCategory === "null") {
        updatedCategory = null;
      }
      const updatedRows = selectedRows.map((row) => ({
        ...row,
        category: updatedCategory,
      }));
      setSelectedRows(updatedRows);
      if (updatedRows.length === 1) {
        const singleRow = updatedRows[0];
        handleRowUpdate(singleRow);
      } else {
        handleMultiRowUpdate(updatedRows);
      }
      setSelectedCategory("");
    }
  }, [selectedCategory]);

  //------------------------------------------------------------------------------------------------------//

  const handleDataFromChild = (childData) => {
    setData(childData);
  };

  const handleBedroomViewClick = (row) => {
    setSelectedRowData(row);
    setOpenBedroomDialog(true);
  };

  const handleAmenitiesViewClick = (row) => {
    setSelectedRowData(row);
    setOpenAmenitiesDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenBedroomDialog(false);
    setOpenAmenitiesDialog(false);
  };

  const handleVirtualTourLinkCopy = (link) => {
    navigator.clipboard
      .writeText(link)
      .then(() => {
        setSnackbarOpen(true);
      })
      .catch((error) => {
        console.error("Failed to copy virtual tour link:", error);
      });
  };

  const handleVirtual = (modal, bed) => {
    setLocalLink((prevState) => ({
      ...prevState,
      [bed]: prevState[bed]?.includes(modal)
        ? prevState[bed]
        : [...(prevState[bed] || []), modal],
    }));
  };

  const updateVirtualTourLink = (updatedData = "") => {
    try {
      if (
        !updatedData ||
        !currentRow ||
        !updatedData?.floor_plan_video ||
        !updatedData?.floor_plan_video_name
      )
        return;

      const updatedPropertyData = currentRow?.units?.map((unit) =>
        unit?.model_name === updatedData?.model_name
          ? {
              ...unit,
              floor_plan_video_name: updatedData?.floor_plan_video_name,
              floor_plan_video: updatedData?.floor_plan_video,
            }
          : unit
      );
      const updatedRow = {
        ...currentRow,
        units: updatedPropertyData,
      };

      const updatedUnitsData = currentUnit?.map((unit) =>
        unit?.model_name === updatedData?.model_name
          ? {
              ...unit,
              floor_plan_video_name: updatedData?.floor_plan_video_name,
              floor_plan_video: updatedData?.floor_plan_video,
            }
          : unit
      );

      setCurrentRow(updatedRow);
      setCurrentUnit(updatedUnitsData);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSelectionChange = (selectionModel) => {
    setIdArray(selectionModel);
  };

  const renderCellContent = (params) => {
    const { field, value, row } = params;
    if (field === "category" && (value === null || value === undefined)) {
      return "-";
    }
    if (typeof value === "object" && value !== null && !Array.isArray(value)) {
      return JSON.stringify(value, null, 2);
    }

    if (field === "name" && row?.website) {
      return (
        <Link href={row?.website} target="_blank" rel="noopener noreferrer">
          {value}
        </Link>
      );
    }

    if (field.includes("email")) {
      const handleEmailClick = (event) => {
        event.stopPropagation();
        navigator.clipboard
          .writeText(value)
          .then(() => {
            setEmailSnackbarOpen(true);
          })
          .catch((error) => {
            console.error("Failed to copy email:", error);
          });
      };

      return (
        <span
          href="#"
          onClick={handleEmailClick}
          style={{ color: "#1976d2", textDecoration: "underline" }}
        >
          {value}
        </span>
      );
    }

    if (field === "actions_copy_mail") {
      // return (
      //   <div className="custom-select">
      //     <Select
      //       style={{ width: 100, color: "#989ca3" }}
      //       value={null}
      //       displayEmpty
      //     >
      //       <MenuItem value={null} disabled>
      //         Show Emails
      //       </MenuItem>
      //       {row.email_1 != null && row.email_1 != "" ? (
      //         <MenuItem
      //           className="line-clamp-1"
      //           key={row.email_1}
      //           value={row.email_1}
      //           onClick={() => handleVirtualTourLinkCopy(row.email_1)}
      //         >
      //           {row.email_1}
      //         </MenuItem>
      //       ) : (
      //         ""
      //       )}
      //       {row.email_2 != null && row.email_2 != "" ? (
      //         <MenuItem
      //           className="line-clamp-1"
      //           key={row.email_2}
      //           value={row.email_2}
      //           onClick={() => handleVirtualTourLinkCopy(row.email_2)}
      //         >
      //           {row.email_2}
      //         </MenuItem>
      //       ) : (
      //         ""
      //       )}
      //       {row.email_3 != null && row.email_3 != "" ? (
      //         <MenuItem
      //           className="line-clamp-1"
      //           key={row.email_3}
      //           value={row.email_3}
      //           onClick={() => handleVirtualTourLinkCopy(row.email_3)}
      //         >
      //           {row.email_3}
      //         </MenuItem>
      //       ) : (
      //         ""
      //       )}
      //       {row.email_4 != null && row.email_4 != "" ? (
      //         <MenuItem
      //           className="line-clamp-1"
      //           key={row.email_4}
      //           value={row.email_4}
      //           onClick={() => handleVirtualTourLinkCopy(row.email_4)}
      //         >
      //           {row.email_4}
      //         </MenuItem>
      //       ) : (
      //         ""
      //       )}
      //     </Select>
      //   </div>
      // );
      const firstEmail = [row?.email_1, row?.email_2, row?.email_3, row?.email_4].find(e => !isEmpty(e));
      return (
        <IconButton
          size="small"
          disabled={isEmpty(firstEmail)}
          onClick={(e) => {
            handleVirtualTourLinkCopy(firstEmail)
            const btn = e.currentTarget;
            // floating indicator
            const tick = document.createElement("span");
            tick.innerText = "✓";
            tick.style.cssText = `
                    position: absolute;
                    font-size: 12px;
                    font-weight: 700;
                    color: #0288d1;
                    pointer-events: none;
                    top: -4px;
                    right: -4px;
                  `;
            btn.style.position = "relative";
            btn.appendChild(tick);
            tick.animate(
              [
                { opacity: 0, transform: "translateY(0px) scale(0.8)" },
                { opacity: 1, transform: "translateY(-6px) scale(1)" },
                { opacity: 0, transform: "translateY(-12px) scale(1)" },
              ],
              { duration: 400, easing: "ease-out", fill: "forwards" }
            ).onfinish = () => tick.remove();

          }}
          title={firstEmail}
        >
          <EmailRounded fontSize="small" color={isEmpty(firstEmail) ? "disabled" : "info"} />
        </IconButton>
      )
    }

    if (field === "virtual_tour") {
      const generateTourLink = (tour) => {
        const baseURL = window.location.origin;
        const encodedURL = btoa(encodeURIComponent(tour?.original));

        if (tour?.Type === "folder") {
          return `${baseURL}/folder?folderUrl=${encodedURL}`;
        } else if (tour?.Type === "document" || tour?.Type === "image") {
          return `${baseURL}/${tour?.Type}?documentUrl=${encodedURL}`;
        } else {
          return `${baseURL}/video?videoUrl=${encodedURL}`;
        }
      };

      const allTours = [
        ...(row?.virtual_tour || [])?.map((tour) => ({
          name:
            tour?.name ||
            (tour?.link?.length > 25
              ? tour?.link.slice(0, 25) + "..."
              : tour?.link),
          link: tour?.link,
        })),
        ...(driveData || [])
          ?.filter(
            (x) =>
              x?.Key?.includes(row?.market?.toLowerCase()) &&
              x?.Key?.includes(row?.name?.toLowerCase() + "/") &&
              !x?.Key?.includes("-thumb-")
          )
          ?.map((tour) => ({
            name: tour?.original?.split("/").pop(),
            link: generateTourLink(tour),
          })),
      ];

      const uniqueTours = Array.from(
        new Map(
          allTours.map((tour) => [`${tour?.name}-${tour?.link}`, tour])
        ).values()
      );

      return (
        <div className="custom-select">
          <Select
            style={{ width: 100, color: "#989ca3" }}
            value={null}
            displayEmpty
          >
            <MenuItem value={null} disabled>
              Show Links
            </MenuItem>

            {uniqueTours?.length > 0 ? (
              uniqueTours?.map((tour, index) => (
                <MenuItem
                  className="line-clamp-1"
                  key={index}
                  value={tour.link}
                  onClick={() => handleVirtualTourLinkCopy(tour.link)}
                >
                  {tour.name}
                </MenuItem>
              ))
            ) : (
              <MenuItem value="">-</MenuItem>
            )}
          </Select>
        </div>
      );
    }

    if (typeof value === "boolean") {
      return value ? "Yes" : "No";
    }

    if (typeof value === "string") {
      try {
        const url = new URL(value);
        if (url.protocol === "http:" || url.protocol === "https:") {
          return (
            <Link href={value} target="_blank" rel="noopener noreferrer">
              {value}
            </Link>
          );
        }
      } catch (error) {
        // console.error("Invalid URL:", error);
      }
      if (value.includes("@") && value.includes(".")) {
        return <Link href={`mailto:${value}`}>{value}</Link>;
      }
      const phoneRegex = /^\d{10}$/;
      if (
        phoneRegex.test(value.replace(/[\s\-\(\)]/g, "")) &&
        value.replace(/[\s\-\(\)]/g, "").length === 10
      ) {
        return <Link href={`tel:${value}`}>{value}</Link>;
      }
    }
    return value;
  };

  const isEmpty = (val) => [undefined, null, ""].includes(val);

  const handleEditIconClick = (id) => {
    setEditId(id);
    setIsPopupOpen(true);
  };

  const handleChange = (propertyIndex, field, value) => {
    const updatedTours = [...tours];
    updatedTours[propertyIndex][field] = value;
    setTours(updatedTours);
  };

  const handleRemove = (propertyIndex) => {
    const updatedTours = [...tours];
    updatedTours.splice(propertyIndex, 1);
    setTours(updatedTours);
  };

  const handleAdd = () => {
    setTours([...tours, { name: "", link: "" }]);
  };

  const handleClosePopup = () => {
    setTours([{ name: "", link: "" }]);
    setIsPopupOpen(false);
    setEditId("");
  };

  const handleSavePopup = () => {
    const updatedIndex = properties.findIndex(
      (property) => property.id === editId
    );
    const filteredVirtualFields = tours.filter((field) => field?.link);
    if (updatedIndex >= 0) {
      const updatedProperty = {
        ...properties[updatedIndex],
        virtual_tour: filteredVirtualFields,
      };

      handleRowUpdate(updatedProperty);
    }

    setIsPopupOpen(false);
  };

  const renderActionButtons = (params) => {
    return (
      <Button
        onClick={(e) => {
          e.stopPropagation();
          handleActionOne(params.row);
        }}
        variant="contained"
        color="primary"
        size="small"
        style={{ minWidth: "40px" }}
      >
        *
      </Button>
    );
  };

  const handleActionOne = (rowData) => {
    const emailContent = `
      <div style="font-size: 16px; font-family: 'Calibri', sans-serif;">
        <p style="font-weight: 700; margin: 0; padding: 0"><a href="${
          rowData?.website
        }">${
      rowData?.name ? rowData?.name + " (" + rowData.website + ")" : " "
    }</a>${
      (
        ((rowData.send == null || rowData.send == "" || rowData.send == 0) &&
          (rowData.bonus == null ||
            rowData.bonus == "" ||
            rowData.bonus == 0) &&
          rowData.escort > 0) ||
        ((rowData.send == 0 || rowData.send == null || rowData.send == "") &&
          rowData.escort != 0 &&
          rowData.escort != null &&
          rowData.escort != "" &&
          rowData.bonus != 0 &&
          rowData.bonus != null &&
          rowData.bonus != "") ||
        (((rowData.send_type == "percentage" &&
          rowData.escort_type == "percentage") ||
          (rowData.send_type == "percentage" && rowData.escort_type == null) ||
          (rowData.send_type == null && rowData.escort_type == "percentage") ||
          (rowData.send_type == null && rowData.escort_type == null)) &&
          rowData.escort > rowData.send) ||
        (rowData.send_type == "dollar" &&
          rowData.escort_type == "dollar" &&
          rowData.escort > rowData.send)
          ? "<b> *if you're interested in touring this property, please let me know, I have to go in person with you to tour in order to receive credit.</b>"
          : ""
      )
        ? "<b> *if you're interested in touring this property, please let me know, I have to go in person with you to tour in order to receive credit.</b>"
        : ""
    }</p>
        <p style="margin: 0; padding: 0">Price: $ <span style="font-weight: 700;">${
          rowData?.special ?? ""
        }</span></p>
        <p style="margin: 0; padding: 0">Size: sq ft 1•1</p>
        <p style="margin: 0; padding: 0">Unit: #</p>
        <p style="margin: 0; padding: 0">Available: - ${
          rowData?.hold_time ? rowData?.hold_time : ""
        }</p>
        <p style="margin: 0; padding: 0">Location: ${
          rowData?.submarket ? rowData?.submarket : ""
        }</p>
        <p style="margin: 0; padding: 0">${
          rowData?.last_line ? rowData?.last_line : ""
        }</p>
      </div>
    `;

    const plainTextContent = `${
      rowData?.name
        ? `${rowData.name} (${rowData.website}) ${
            (
              ((rowData.send == null ||
                rowData.send == "" ||
                rowData.send == 0) &&
                (rowData.bonus == null ||
                  rowData.bonus == "" ||
                  rowData.bonus == 0) &&
                rowData.escort > 0) ||
              ((rowData.send == 0 ||
                rowData.send == null ||
                rowData.send == "") &&
                rowData.escort != 0 &&
                rowData.escort != null &&
                rowData.escort != "" &&
                rowData.bonus != 0 &&
                rowData.bonus != null &&
                rowData.bonus != "") ||
              (((rowData.send_type == "percentage" &&
                rowData.escort_type == "percentage") ||
                (rowData.send_type == "percentage" &&
                  rowData.escort_type == null) ||
                (rowData.send_type == null &&
                  rowData.escort_type == "percentage") ||
                (rowData.send_type == null && rowData.escort_type == null)) &&
                rowData.escort > rowData.send) ||
              (rowData.send_type == "dollar" &&
                rowData.escort_type == "dollar" &&
                rowData.escort > rowData.send)
                ? "<b> *if you're interested in touring this property, please let me know, I have to go in person with you to tour in order to receive credit.</b>"
                : ""
            )
              ? "*if you're interested in touring this property, please let me know, I have to go in person with you to tour in order to receive credit."
              : ""
          }`
        : ""
    }
Price: $ ${rowData?.special ?? ""}
Size: sq ft 1/1
Unit: #
Available: - ${rowData?.hold_time ? rowData?.hold_time : ""}
Location: ${rowData?.submarket ? rowData?.submarket : ""}
${rowData?.last_line ? rowData?.last_line : ""}`;

    navigator.clipboard
      .write([
        new ClipboardItem({
          "text/html": new Blob([emailContent], { type: "text/html" }),
          "text/plain": new Blob([plainTextContent], { type: "text/plain" }),
        }),
      ])
      .then(() => {
        console.log("Email info copied to clipboard!");
        setSnackbarOpen(true);
      })
      .catch((err) => {
        console.error("Failed to copy email info: ", err);
      });
  };

  const RenderViewToggleButtonNewCalculator = (params) => {
    return (
      <Button title="Calculated Special New">
        <CalculateIcon
          color="success"
          onClick={(e) => {
            setCalculator({ data: params?.row || null, open: true });
          }}
        />
      </Button>
    );
  };

  const handleClick = async (event, row) => {
    setAnchorEl(event?.currentTarget);
    setActiveRowId(row?.id);
    await getAllSpecialsByPropertyId(row?.id); // Assuming property_id is available
  };

  const getAllSpecialsByPropertyId = async (propertyId) => {
    try {
      await axiosInstance
        .get(`${process.env.REACT_APP_API_URL}/specials/${propertyId}`)
        .then((res) => {
          const specialsData = res?.data?.data || [];
          setAllAspecials(specialsData);
        })
        .catch((error) => {
          setAllAspecials([]);
          console.error("Error fetching specials:", error);
        });
    } catch (error) {
      console.error("Unexpected error:", error);
      setAllAspecials([]);
    }
  };

  const handleDeleteFilter = async (filterId) => {
    try {
      await axiosInstance.delete(
        `${process.env.REACT_APP_API_URL}/specials/delete/${filterId}`
      );
      const updated = allASpecials.filter((f) => f?.id !== filterId);
      setAllAspecials(updated);
    } catch (err) {
      console.error("Failed to delete filter:", err);
    }
  };

  const renderSpecialCellContentNew = (params) => {
    const { row } = params;
    const open = Boolean(anchorEl) && activeRowId === row.id;
    const id = open ? `popover-${row.id}` : undefined;

    return (
      <>
        <IconButton size="small" onClick={(e) => handleClick(e, row)}>
          <InfoOutlinedIcon color="info" fontSize="small" />
        </IconButton>

        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={() => {
            setAnchorEl(null);
            setActiveRowId(null);
            setAllAspecials([]);
          }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          PaperProps={{
            sx: {
              p: 2,
              width: 400,
              maxWidth: "90vw",
              borderRadius: 2,
              boxShadow: 4,
              backgroundColor: "#fefefe",
            },
          }}
        >
          <h6 className="text-lg">Saved Specials</h6>

          {allASpecials.length === 0 ? (
            <Typography variant="body2" color="text.secondary">
              No Specials saved for this property.
            </Typography>
          ) : (
            <Box sx={{ maxHeight: 300, overflowY: "auto", pr: 1 }}>
              <Stack spacing={2}>
                {allASpecials.map((filter, i) => (
                  <Paper
                    key={filter._id || i}
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: "#fafafa",
                      position: "relative",
                    }}
                  >
                    <IconButton
                      size="small"
                      color="error"
                      onClick={() => handleDeleteFilter(filter?.id)}
                      sx={{ position: "absolute", top: 8, right: 8 }}
                    >
                      <DeleteOutlineIcon color="error" fontSize="small" />
                    </IconButton>

                    <Stack spacing={1}>
                      {filter?.floor_plans?.length > 0 && (
                        <Box display="flex" alignItems="center" gap={1}>
                          <ApartmentOutlinedIcon
                            fontSize="small"
                            color="action"
                          />
                          <Typography variant="body2">
                            <strong>Floor Plans:</strong>{" "}
                            {filter.floor_plans.join(", ")}
                          </Typography>
                        </Box>
                      )}

                      {filter?.unit_numbers?.length > 0 && (
                        <Box display="flex" alignItems="center" gap={1}>
                          <NumbersOutlinedIcon
                            fontSize="small"
                            color="action"
                          />
                          <Typography variant="body2">
                            <strong>Unit Numbers:</strong>{" "}
                            {filter.unit_numbers.join(", ")}
                          </Typography>
                        </Box>
                      )}

                      {filter?.unit_types?.length > 0 && (
                        <Box display="flex" alignItems="center" gap={1}>
                          <LabelOutlinedIcon fontSize="small" color="action" />
                          <Typography variant="body2">
                            <strong>Unit Types:</strong>{" "}
                            {filter.unit_types.join(", ")}
                          </Typography>
                        </Box>
                      )}

                      {filter?.lease_term && (
                        <Box display="flex" alignItems="center" gap={1}>
                          <CalendarTodayOutlinedIcon
                            fontSize="small"
                            color="action"
                          />
                          <Typography variant="body2">
                            <strong>Lease Term:</strong> {filter.lease_term} mo
                          </Typography>
                        </Box>
                      )}

                      <Box display="flex" flexWrap="wrap" gap={1} mt={1}>
                        {filter?.months_free && (
                          <Chip
                            label={`+${filter.months_free} mo free`}
                            size="small"
                            color="success"
                            variant="outlined"
                          />
                        )}
                        {filter?.custom_concession && (
                          <Chip
                            label={`$${filter.custom_concession} concession`}
                            size="small"
                            color="info"
                            variant="outlined"
                          />
                        )}
                        {filter?.notes && (
                          <Chip
                            label={`Note : ${filter.notes}`}
                            size="small"
                            color="warning"
                            variant="outlined"
                          />
                        )}
                      </Box>
                    </Stack>
                  </Paper>
                ))}
              </Stack>
            </Box>
          )}
        </Popover>
      </>
    );
  };

  const generateColumns = () => {
    const baseColumns = [
      // {
      //   field: "actions",
      //   headerName: "Copy",
      //   width: 60,
      //   renderCell: renderActionButtons,
      // },
      {
        field: "actions_copy_mail",
        headerName: "Email",
        width: 60,
        renderCell: renderCellContent,
      },
      {
        field: "id",
        headerName: "Id",
        editable: true,
        width: 100,
      },
      {
        field: "name",
        headerName: "Name",
        editable: true,
        width: 150,
        renderCell: renderCellContent,
      },
      {
        field: "send",
        headerName: "Send",
        // editable: true,
        width: 60,
        renderCell: (params) => (
          <EditSendField
            params={params}
            selectedRows={selectedRows}
            setFilteredProperties={setFilteredProperties}
            handleRowUpdate={handleRowUpdate}
          />
        ),
      },
      {
        field: "escort",
        headerName: "Escort",
        // editable: true,
        width: 60,
        renderCell: (params) => (
          <EditEscortField
            params={params}
            selectedRows={selectedRows}
            setFilteredProperties={setFilteredProperties}
            handleRowUpdate={handleRowUpdate}
          />
        ),
      },
      {
        field: "bonus",
        headerName: "Bonus",
        editable: true,
        width: 60,
        renderCell: (params) => (
          <span>{!isEmpty(params?.value) ? `$${params?.value}` : ""}</span>
        ),
      },
      // {
      //   field: "category",
      //   headerName: "Category",
      //   editable: true,
      //   width: 150,
      //   renderCell: renderCellContent,
      //   renderEditCell: (params) => (
      //     <Select
      //       className="w-full"
      //       value={params.value || ""}
      //       onChange={(e) => {
      //         handleApplyCategory(e.target.value);
      //         handleRowUpdate(
      //           currentSelectedData?.row,
      //           {},
      //           currentSelectedData?.field,
      //           e.target.value
      //         );
      //         params.api.setEditCellValue({ ...params, value: e.target.value });
      //       }}
      //     >
      //       {[
      //         ["null", "-"],
      //         ["Not working with locators", "Not working with locators"],
      //         ["Student Housing", "Student Housing"],
      //         ["Affordable Housing", "Affordable Housing"],
      //         ["Do not add", "Do not add"],
      //         ["Unsure", "Unsure"],
      //       ].map(([val, label]) => (
      //         <MenuItem key={val} value={val}>
      //           {label}
      //         </MenuItem>
      //       ))}
      //     </Select>
      //   ),
      // },
      {
        field: "virtual_tour",
        headerName: "Virtual Tour",
        width: 100,
        sortable: false,
        renderCell: renderCellContent,
      },
      {
        field: "virtual_tour_edit",
        type: "actions",
        width: 20,
        cellClassName: "actions",
        getActions: ({ id }) => [
          <GridActionsCellItem
            icon={<EditIcon style={{ color: "#0075FF" }} />}
            label="Edit"
            onClick={() => handleEditIconClick(id)}
            color="inherit"
          />,
        ],
      },
      {
        field: "new_special_toggle",
        type: "actions",
        align: "center",
        width: 50,
        renderCell: RenderViewToggleButtonNewCalculator,
      },
      {
        field: "specials",
        headerName: "Specials",
        type: "actions",
        align: "center",
        width: 80,
        renderCell: renderSpecialCellContentNew,
      },
      {
        field: "bedrooms_view",
        headerName: "Beds",
        width: 60,
        renderCell: (params) => (
          <IconButton onClick={() => handleBedroomViewClick(params.row)}>
            <BedIcon color="info" />
          </IconButton>
        ),
      },
      {
        field: "amenities_view",
        headerName: "Amens",
        width: 60,
        renderCell: (params) => (
          <IconButton onClick={() => handleAmenitiesViewClick(params.row)}>
            <BathtubIcon color="info" />
          </IconButton>
        ),
      },
    ];

    const dynamicColumns = [];

    if (properties?.length > 0) {
      const excludeKeys = [
        "category",
        "id",
        "name",
        "escort_type",
        "send_type",
        "phone",
        "virtual_tour",
        "number_units",
        "bonus",
        "send",
        "escort",
        "yard_location",
        "special_toggle",
        "special",
        "townhome",
        "number_floors",
        "admin_fee",
        "application_fee",
      ];

      Object.keys(properties[0]).forEach((key) => {
        if (excludeKeys.includes(key)) return;

        const isSpecialWidth = customWidthColumns.includes(key);

        let column = {
          field: key,
          headerName:
            key === "special_toggle"
              ? ""
              : key === "single_family" ? "Townhome/Single Family" : key.replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase()),
          width:
            key === "special_toggle" || key === "year_built_renovated" || key === "year_built"
              ? 80
              : isSpecialWidth
              ? 100
              : key === "submarket"
              ? 100
              : 150,
          editable: key !== "send" && key !== "escort",
          renderCell:
            key === "send"
              ? EditSendField
              : key === "escort"
              ? EditEscortField
              : renderCellContent,
        };

        if (key === "building_class") {
          column.renderEditCell = (params) => (
            <Select
              className="w-full"
              value={params.value || ""}
              onChange={(e) =>
                params.api.setEditCellValue({
                  ...params,
                  value: e.target.value,
                })
              }
            >
              {["-", "Townhome/Single Family", "High Rise"].map((label) => (
                <MenuItem key={label} value={label === "-" ? null : label}>
                  {label}
                </MenuItem>
              ))}
            </Select>
          );
        }

        // if (key === "special_toggle") {
        //   column.renderCell = (params) => (
        //     <Button title="Calculated Special">
        //       <CalculateIcon
        //         onClick={() => {
        //           setWidth(true);
        //           if (!specialData?.term_length_studio)
        //             setSpecialData(params.row);
        //           setCurrentId(params.row);
        //           setTermLengthProp(params.row.term_length);
        //           setMonthFeeProp(params.row.months_fee);
        //           setMonthFeeReferenceProp(params.row.months_fee_reference);
        //           setRentConcessionProp(params.row.rent_concession);
        //           setRentConcessionReferenceProp(
        //             params.row.rent_concession_reference
        //           );
        //           setIsDropdownOpen(true);
        //         }}
        //       />
        //     </Button>
        //   );
        // }

        if (
          [
            "bonus",
            // "admin_fee",
            // "application_fee",
            "studio_price",
            "one_bed_price",
            "two_bed_price",
            "three_bed_price",
            "four_plus_bed_price",
          ].includes(key)
        ) {
          column.renderCell = (params) => (
            <span>{!isEmpty(params?.value) ? `$${params?.value}` : ""}</span>
          );
        }

        if (key === "one_and_a_half_bath") {
          column = {
            field: key,
            headerName: "1.5 Bath",
            editable: true,
            width: 100,
            renderCell: renderCellContent,
          };
        }

        dynamicColumns.push(column);
      });
    }

    const trailingColumns = [
      {
        field: "star",
        headerName: "",
        width: 10,
        sortable: false,
        renderCell: renderStartButton,
        disableClickEventBubbling: true,
      },
      {
        field: "apartment_url1",
        headerName: "View Units",
        width: 80,
        renderCell: renderViewDetailsButton,
        disableClickEventBubbling: true,
      }
    ];

    if(hasAllPermissions(user, [PERMISSIONS.PROPERTY_DELETE])){
      trailingColumns.push({
        field: "black",
        headerName: "Delete",
        width: 60,
        renderCell: renderDeleteButton,
      })
    }

    return [...baseColumns, ...dynamicColumns, ...trailingColumns];
  };

  const renderDeleteButton = (params) => {
    return (
      <Button
        onClick={async (e) => {
          e.stopPropagation();
          setCurrentProperty(params?.row);
          setDeletePopup(true);
        }}
        variant="contained"
        color="primary"
        size="small"
        style={{ minWidth: "40px" }}
      >
        <DeleteIcon />
      </Button>
    );
  };

  const handleRowUpdate = async (newRow, _, isGarageOrYard, category) => {
    delete newRow.units;
    delete newRow.models;
    delete newRow.move_in_special;
    if (category != null && category !== "") newRow.category = category;
    // if (!user || user.role !== "admin") {
    //   console.log("User is not authorized to update rows.");
    // } else {
      try {
        const response = await axiosInstance.put(
          `${process.env.REACT_APP_API_URL}/property/${newRow.id}`,
          {
            data: newRow,
            isYard: isGarageOrYard === "yard_unit" ? true : false,
            isGarage: isGarageOrYard === "garage_unit" ? true : false,
          }
        );
        setFilteredProperties((prev) => {
          const oldData = [...prev];
          const index = oldData.findIndex((x) => x?.id === newRow?.id);
          if (index > -1) {
            oldData[index] = newRow;
          }
          return oldData;
        });
        await fetchData();
        return response?.data;
      } catch (error) {
        console.error("Error updating row:", error);
        throw new Error("Could not update row. Please try again.");
      }
    //}
  };

  const handleMultiRowUpdate = async (updatedRows) => {
    // if (!user || user.role !== "admin") {
    //   console.log("User is not authorized to update rows.");
    // } else {
      try {
        const response = await axiosInstance.post(
          `${process.env.REACT_APP_API_URL}/property/batchUpdate`,
          { rows: updatedRows }
        );
        await fetchData();
        setFilteredProperties((prev) => {
          const oldData = [...prev];
          updatedRows.forEach((newRow) => {
            const index = oldData.findIndex((x) => x?.id === newRow?.id);
            if (index > -1) {
              oldData[index] = newRow;
            }
          });
          return oldData;
        });

        return response.data;
      } catch (error) {
        console.error("Error updating rows:", error);
        throw new Error("Could not update rows. Please try again.");
      }
    //}
  };

  const renderStartButton = (params) => {
    if (params.row.apartment_url?.includes("sightmap")) {
      return <StarsIcon style={{ color: "blue" }} />;
    } else if (params.row.apartment_url_type?.toLowerCase() === "ap") {
      return (
        <div style={{ borderRadius: "50%" }}>
          <FontDownloadIcon style={{ color: "green", borderRadius: "50%" }} />
        </div>
      );
    } else if (params.row.apartment_url?.includes("realpage")) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItem: "center",
            width: "100%",
          }}
        >
          <img src={realPageLogo} style={{ width: "20px" }} />
        </div>
      );
    } else if (params.row.apartment_url_type?.toLowerCase() === "rpt") {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItem: "center",
            width: "100%",
          }}
        >
          <img src={realPageLogo} style={{ width: "20px" }} />
        </div>
      );
    } else if (params.row.apartment_url_type?.toLowerCase() === "ipm") {
      return <ChangeHistoryIcon style={{ color: "red" }} />;
    } else if (params.row.apartment_url_type?.toLowerCase() === "fp") {
      return <HomeIcon style={{ color: "red" }} />;
    } else if (params.row.apartment_url_type?.toLowerCase() === "tx") {
      return <OpenWith style={{ color: "#CB2957" }} />;
    } else if (params.row.apartment_url_type?.toLowerCase() === "afp") {
      return <SentimentVerySatisfied style={{ color: "#ff9f05" }} />;
    } else if (params.row.apartment_url_type?.toLowerCase()?.split('-')?.[0] === "afp3") {
      return <Favorite style={{ color: "#ff2a27" }} />;
    } else if (params.row.apartment_url_type?.toLowerCase() === "afp4") {
      return <HomeIcon style={{ color: "#1400ef" }} />;
    } else if (params.row.apartment_url_type?.toLowerCase() === "afp5") {
      return <HomeIcon style={{ color: "green" }} />;
    } else if (params.row.apartment_url_type?.toLowerCase() === "afp7") {
      return <HomeIcon style={{ color: "#fe0e9e" }} />;
    }
  };

  const renderViewDetailsButton = (params) => {
    if (params.row.apartment_url != null && params.row.apartment_url != "") {
      return (
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={toggleDrawer(true, params.row)}
          style={{ minWidth: "40px" }}
        >
          View
        </Button>
      );
    }
  };

  const loadSwitch = () => {
    setHideTab(false);
    setCurrentRow([]);
    setCurrentUnit([]);
    viewDetails(currentRowData, true, true);
  };

  const viewDetails = async (rowData, open, refresh) => {
    setIsSightMap(rowData?.apartment_url_type);
    try {
      if (rowData?.id) {
        setPropertyId(rowData?.id);
        const response = await axiosInstance
          .post(`${process.env.REACT_APP_API_URL}/view-units/${rowData?.id}`)
          .then((res) => {
            let unitValue = properties.find((x) => x.id == rowData?.id);
            setTempUnit(res.data);
            if (notAvailable) setCurrentUnit(res.data);
            else {
              if (
                rowData?.apartment_url_type === "RP" ||
                rowData?.apartment_url_type === "SM"
              ) {
                setCurrentUnit(res?.data?.filter((x) => x.archived == false));
              } else {
                setCurrentUnit(
                  res.data.filter(
                    (x) =>
                      !x?.unit_details?.includes("Not Available") &&
                      x.archived == false
                  )
                );
              }
            }
            setCurrentRow(properties.find((x) => x.id == rowData?.id));
            let bed = properties.find((x) => x.id == rowData?.id);
            if (properties.find((x) => x.id == rowData?.id))
              unitValue["units"] = res.data;
            if (bed != null) {
              setBedCount({
                studio: unitValue.units.filter((x) => x.unit_studio == true)
                  .length,
                one_bed: unitValue.units.filter((x) => x.unit_bedroom == 1)
                  .length,
                two_bed: unitValue.units.filter((x) => x.unit_bedroom == 2)
                  .length,
                three_bed: unitValue.units.filter((x) => x.unit_bedroom == 3)
                  .length,
                four_plus_bed: unitValue.units.filter(
                  (x) => x.unit_bedroom >= 4
                ).length,
              });
            }
            if (bed != null) {
              let val =
                properties
                  .find((x) => x.id == rowData?.id)
                  .units.filter((x) => x.unit_studio == true).length > 0
                  ? 0
                  : properties
                      .find((x) => x.id == rowData?.id)
                      .units.filter((x) => x.unit_bedroom == 1).length > 0
                  ? 1
                  : properties
                      .find((x) => x.id == rowData?.id)
                      .units.filter((x) => x.unit_bedroom == 2).length > 0
                  ? 2
                  : properties
                      .find((x) => x.id == rowData?.id)
                      .units.filter((x) => x.unit_bedroom == 3).length > 0
                  ? 3
                  : 4;
              if (!refresh) setCurrentIndex(val);
            }
            setHideTab(true);
          });
      }
      setIsDrawerOpen(open);
    } catch (error) {
      console.error("Error updating row:", error);
      throw new Error("Could not update row. Please try again.");
    }
  };

  const reduceWidth = (cancel) => {
    setWidth(cancel);
  };

  const handleClose = () => {
    setContextMenu(null);
    setShowCategory(null);
  };

  const handleCategoryChange = (category) => {
    setShowCategory(category);
    setSubMenuOpen(true);
  };

  const handleApplyCategory = (category) => {
    setSelectedCategory(category);
    handleClose();
  };

  const handleSubMenuClose = () => {
    setSubMenuOpen(false);
  };

  const handleContextMenu = (event) => {
    event.preventDefault();
    setContextMenu(
      contextMenu === null
        ? {
            mouseX: event.clientX + 2,
            mouseY: event.clientY - 6,
          }
        : null
    );
  };

  const handleCloseSnackbar = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const handleCloseEmailSnackbar = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setEmailSnackbarOpen(false);
  };

  const generateCsvName = () => {
    const date = new Date();
    const formattedDate = `${
      date.getMonth() + 1
    }_${date.getDate()}_${date.getFullYear()}`;
    return `sidekick_${formattedDate}.csv`;
  };

  const CustomToolbar = () => {
    const handleExport = async () => {
      try {
        setExporting(true);
        const response = await axiosInstance.get(
          `${process.env.REACT_APP_API_URL}/export-csv`,
          {
            responseType: "blob",
          }
        );

        const url = window.URL.createObjectURL(new Blob([response?.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", generateCsvName());
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error downloading the CSV file:", error);
      } finally {
        setExporting(false);
      }
    };

    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />

        <Button 
        color="primary" 
        onClick={handleExport}
        disabled={exporting} 
        startIcon={
          exporting ? <CircularProgress size={18} color="inherit" /> : <SaveIcon />
        }
        >
          {exporting ? "Exporting..." : "Export"}
        </Button>
      </GridToolbarContainer>
    );
  };

  const toggleDrawer = (open, params) => (event) => {
    setIsSightMap(params?.apartment_url_type);
    setCurrentRowData(params);
    viewDetails(params, open);
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    if (!open) {
      setCurrentRowData({});
      setTabIndex(0);
      setPropertyDetails({});
      setIsDrawerOpen(open);
      setNotAvailable(false);
    }
  };

  const handleTabChange = async (event, newIndex) => {
    if (event.target.innerText == "STUDIO") setCurrentIndex(0);
    if (event.target.innerText == "1 BED") setCurrentIndex(1);
    if (event.target.innerText == "2 BED") setCurrentIndex(2);
    if (event.target.innerText == "3 BED") setCurrentIndex(3);
    if (event.target.innerText == "4 BED") setCurrentIndex(4);
    setTabIndex(newIndex);
  };

  const handleCellClick = (params, event) => {
    if (params.field === "apartment_url1") {
      event.stopPropagation();
    }
  };

  const openTabVirtualTour = async (e) => {
    if (e.length > 0) {
      let delay = 2000;
      e.forEach((url, index) => {
        setTimeout(() => {
          window.open(url.link, "_blank");
        }, index * delay);
      });
    }
  };

  const handleSubmit = async (
    submit,
    leaseTerm,
    monthsFree,
    rentConcession,
    monthsFreeReference,
    rentConcessionReference,
    bool
  ) => {
    try {
      setSpecialData({});

      setSpecialData((prev) => ({
        ...prev,
        leaseTerm: leaseTerm,
        monthsFree: monthsFree,
        monthsFreeReference: monthsFreeReference,
        rentConcession: rentConcession,
        rentConcessionReference: rentConcessionReference,
      }));

      if (currentId?.id > 0 || submit?.id > 0) {
        setModalLoader(true);

        const response = await axiosInstance
          .put(
            `${process.env.REACT_APP_API_URL}/property-unit/${
              currentId?.id ?? submit?.id
            }`,
            {
              leaseTerm,
              monthsFree,
              rentConcession,
              monthsFreeReference,
              rentConcessionReference,
              specialToggle: bool,
            }
          )
          .then((res) => {
            refresh(2000);
            setModalLoader(false);
            setIsDropdownOpen(false);
          });
        return response?.data;
      }
    } catch (error) {
      console.error("Error updating row:", error);
      throw new Error("Could not update row. Please try again.");
    }
  };

  const handleCancel = (cancel) => {
    setIsDropdownOpen(false);
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: width ? 400 : 1000,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const handleCellDoubleClick = (params) => {
    setCurrentSelectedData(params);
    if (
      params?.field !== "category" &&
      params?.field !== "virtual_tour_edit" &&
      params?.field !== "virtual_tour" &&
      params?.field !== "send" &&
      params?.field !== "escort"
    ) {
      if (typeof params.value != "boolean") setSelectedCellData(params.value);
      if (typeof params.value == "boolean")
        setSelectedCellData(params.value ? "Yes" : "No");
      setIsDoubleClickPopupOpen(true);
    }
  };

  const handleCloseDoubleClick = () => {
    setIsDoubleClickPopupOpen(false);
  };

  const handleDeletePopUp = () => {
    setDeletePopup(false);
  };

  return (
    <div>
      <PermissionWrapper permissions={[PERMISSIONS.PROPERTY_DELETE]}>
        <div
          style={{
            paddingRight: "10px",
            paddingBottom: "10px",
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            onClick={async (e) => {
              await axiosInstance
                .post(`${process.env.REACT_APP_API_URL}/deletePropertyGroup`, {
                  propertyId: idArray,
                })
                .then(async () => {
                  await fetchData();
                });
            }}
            variant="contained"
            disabled={idArray?.length > 0 ? false : true}
          >
            Delete
          </Button>
        </div>
      </PermissionWrapper>
      <div className="mx-auto p-4 bg-white rounded-lg">
        <Modal
          open={isDropdownOpen}
          BackdropProps={{
            onClick: (event) => handleCancel(),
          }}
          onClose={() => {
            setIsDropdownOpen(false);
            setCurrentId({});
            handleCancel();
            setWidth(true);
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            {modalLoader && (
              <Box
                sx={{
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <CircularProgress disableShrink />
              </Box>
            )}
            {!modalLoader && (
              <ProrationCalculator
                monthFee={monthFeeProp}
                monthFeeReference={monthFeePropReferenceProp}
                rentConcessions={rentConcessionProp}
                rentConcessionReferences={rentConcessionReferenceProp}
                termLength={termLengthProp}
                isSpecial={true}
                specialData={specialData}
                submit={handleSubmit}
                cancel={handleCancel}
                reduceWidth={reduceWidth}
              />
            )}
          </Box>
        </Modal>
        <div>
          <Drawer
            anchor="right"
            open={isDrawerOpen}
            onClose={toggleDrawer(false)}
            sx={{ "& .MuiDrawer-paper": { width: "80%", boxShadow: "unset" } }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "10px",
              }}
            >
              <IconButton onClick={toggleDrawer(false)}>
                <CloseIcon />
              </IconButton>
            </div>
            <div>
              <div>
                <div
                  style={{
                    marginTop: "20px",
                    color: "#4e5c76",
                    fontSize: "40px",
                    marginLeft: "30px",
                    marginRight: "30px",
                    fontWeight: "800",
                  }}
                >
                  {currentRow?.name}
                </div>
                <div>
                  <div
                    class="grid grid-cols-4 gap-4"
                    style={{
                      paddingBottom: "20px",
                      paddingRight: "30px",
                      paddingLeft: "30px",
                    }}
                  >
                    {currentRow && currentRow.street_address && (
                      <div>
                        <LocationOnIcon style={{ color: "#4e5c76" }} />
                        &nbsp;&nbsp;
                        {currentRow.street_address}
                      </div>
                    )}
                    {currentRow && currentRow.website && (
                      <div>
                        <LanguageIcon style={{ color: "#4e5c76" }} />
                        &nbsp;&nbsp;
                        <a
                          href={currentRow.website}
                          target="_blank"
                          style={{ textDecoration: "underline" }}
                        >
                          Website
                        </a>
                      </div>
                    )}
                    {currentRow && currentRow.google_maps_url && (
                      <div>
                        <MapIcon style={{ color: "#4e5c76" }} />
                        &nbsp;&nbsp;
                        <a
                          href={currentRow.google_maps_url}
                          target="_blank"
                          style={{ textDecoration: "underline" }}
                        >
                          Map
                        </a>
                      </div>
                    )}
                    {currentRow && currentRow.virtual_tour && (
                      <div>
                        <VideocamIcon style={{ color: "#4e5c76" }} />
                        &nbsp;&nbsp;
                        <span
                          onClick={() =>
                            openTabVirtualTour(currentRow.virtual_tour)
                          }
                          style={{ textDecoration: "underline" }}
                        >
                          Virtual Tour
                        </span>
                      </div>
                    )}
                    {currentRow && currentRow.phone && (
                      <div>
                        <PhoneIcon style={{ color: "#4e5c76" }} />
                        &nbsp;&nbsp;
                        <span style={{ textDecoration: "underline" }}>
                          {currentRow.phone}
                        </span>
                      </div>
                    )}
                    {currentRow && currentRow.email && (
                      <div>
                        <MarkunreadIcon style={{ color: "#4e5c76" }} />
                        &nbsp;&nbsp;
                        <span style={{ textDecoration: "underline" }}>
                          {currentRow.email}
                        </span>
                      </div>
                    )}
                    {currentRow && currentRow.year_built && (
                      <div>
                        <CalendarMonthIcon style={{ color: "#4e5c76" }} />
                        &nbsp;&nbsp; Build Year: &nbsp;
                        {currentRow.year_built}
                      </div>
                    )}
                    {currentRow && currentRow.year_renovated && (
                      <div>
                        <CalendarMonthIcon style={{ color: "#4e5c76" }} />
                        &nbsp;&nbsp; Renovated Year: &nbsp;
                        {currentRow.year_renovated}
                      </div>
                    )}
                    {currentRow && currentRow.escort && (
                      <div>
                        <SecurityIcon style={{ color: "#4e5c76" }} />
                        &nbsp;&nbsp; Escort %: &nbsp;{currentRow.escort}
                      </div>
                    )}
                    {currentRow && currentRow.send && (
                      <div>
                        <SecurityIcon style={{ color: "#4e5c76" }} />
                        &nbsp;&nbsp; Send %: &nbsp;{currentRow.send}
                      </div>
                    )}
                    {currentRow && currentRow.hold_time && (
                      <div>
                        <AccessTimeIcon style={{ color: "#4e5c76" }} />
                        &nbsp;&nbsp; Hold Time: &nbsp;{currentRow.hold_time}
                      </div>
                    )}
                  </div>
                </div>
                {data && (
                  <div
                    style={{
                      margin: "30px",
                      height: "10vh",
                      display: "flex",
                      alignItems: "center",
                      background: "#f5fbfc",
                      border: ".0625rem dashed #0f8ac0",
                    }}
                  >
                    <div style={{ marginLeft: "20px", display: "flex" }}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <LocalOfferIcon style={{ color: "#4e5c76" }} />
                      </div>
                      &nbsp;&nbsp;
                      <div>
                        <div style={{ fontSize: "20px" }}>Move-in Special</div>
                        <div style={{ fontSize: "15px" }}>{data}</div>
                      </div>
                    </div>
                  </div>
                )}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "right",
                    width: "100%",
                    alignItems: "center",
                  }}
                >
                  <Switch
                    onChange={() => {
                      if (!notAvailable) setCurrentUnit(tempUnit);
                      else {
                        if (isSightMap === "SM" || isSightMap === "RP") {
                          setCurrentUnit(
                            tempUnit?.filter((x) => x.archived == false)
                          );
                        } else {
                          setCurrentUnit(
                            tempUnit?.filter(
                              (x) =>
                                !x?.unit_details?.includes("Not Available") &&
                                x.archived == false
                            )
                          );
                        }
                      }
                      setNotAvailable(!notAvailable);
                    }}
                  />
                  <label style={{ marginRight: "30px", fontWeight: 800 }}>
                    View Unavailable Units
                  </label>
                </div>
                {!hideTab && (
                  <Box
                    sx={{
                      position: "relative",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <CircularProgress disableShrink />
                  </Box>
                )}
                {hideTab && (
                  <>
                    <Tabs
                      value={tabIndex}
                      onChange={handleTabChange}
                      aria-label="basic tabs example"
                      sx={{
                        backgroundColor: "white",
                        color: "#4e5c76",
                        "& .MuiTab-root": {
                          backgroundColor: "#f8f8f8",
                          color: "#4e5c76",
                          "&.Mui-selected": {
                            backgroundColor: "#4e5c76",
                            color: "white",
                          },
                        },
                        marginRight: "30px",
                        marginLeft: "30px",
                      }}
                    >
                      {bedCount.studio > 0 && (
                        <Tab
                          label="STUDIO"
                          style={{ borderTopLeftRadius: "20px" }}
                        />
                      )}
                      {bedCount.one_bed > 0 && (
                        <Tab
                          label="1 BED"
                          style={{
                            borderTopLeftRadius:
                              bedCount.studio == 0 ? "20px" : "",
                            borderTopRightRadius:
                              bedCount.two_bed == 0 &&
                              bedCount.three_bed == 0 &&
                              bedCount.four_plus_bed == 0
                                ? "20px"
                                : "",
                          }}
                        />
                      )}
                      {bedCount.two_bed > 0 && (
                        <Tab
                          label="2 BED"
                          style={{
                            borderTopLeftRadius:
                              bedCount.studio == 0 && bedCount.one_bed == 0
                                ? "20px"
                                : "",
                            borderTopRightRadius:
                              bedCount.three_bed == 0 &&
                              bedCount.four_plus_bed == 0
                                ? "20px"
                                : "",
                          }}
                        />
                      )}
                      {bedCount.three_bed > 0 && (
                        <Tab
                          label="3 bed"
                          style={{
                            borderTopLeftRadius:
                              bedCount.studio == 0 &&
                              bedCount.one_bed == 0 &&
                              bedCount.two_bed == 0
                                ? "20px"
                                : "",
                            borderTopRightRadius:
                              bedCount.four_plus_bed == 0 ? "20px" : "",
                          }}
                        />
                      )}
                      {bedCount.four_plus_bed > 0 && (
                        <Tab
                          label="4 bed"
                          style={{ borderTopRightRadius: "20px" }}
                        />
                      )}
                    </Tabs>
                    <TabPanel value={tabIndex} index={0}>
                      <TabProperties
                        propertyDetails={currentRow}
                        bedCount={"studio"}
                        currentRow={currentRow}
                        current={currentIndex}
                        currentUnit={currentUnit}
                        virtual={handleVirtual}
                        updateVirtualTourLink={updateVirtualTourLink}
                        localLink={localLink}
                        onData={handleDataFromChild}
                        loadSwitch={loadSwitch}
                        driveData={driveData}
                      />
                    </TabPanel>
                    <TabPanel value={tabIndex} index={1}>
                      <TabProperties
                        propertyDetails={currentRow}
                        bedCount={"1 bed"}
                        currentRow={currentRow}
                        current={currentIndex}
                        currentUnit={currentUnit}
                        virtual={handleVirtual}
                        updateVirtualTourLink={updateVirtualTourLink}
                        localLink={localLink}
                        onData={handleDataFromChild}
                        loadSwitch={loadSwitch}
                        driveData={driveData}
                      />
                    </TabPanel>
                    <TabPanel value={tabIndex} index={2}>
                      <TabProperties
                        propertyDetails={currentRow}
                        bedCount={"2 bed"}
                        currentRow={currentRow}
                        current={currentIndex}
                        currentUnit={currentUnit}
                        virtual={handleVirtual}
                        updateVirtualTourLink={updateVirtualTourLink}
                        localLink={localLink}
                        onData={handleDataFromChild}
                        loadSwitch={loadSwitch}
                        driveData={driveData}
                      />
                    </TabPanel>

                    <TabPanel value={tabIndex} index={3}>
                      <TabProperties
                        propertyDetails={currentRow}
                        currentRow={currentRow}
                        bedCount={"3 bed"}
                        current={currentIndex}
                        currentUnit={currentUnit}
                        virtual={handleVirtual}
                        updateVirtualTourLink={updateVirtualTourLink}
                        localLink={localLink}
                        onData={handleDataFromChild}
                        loadSwitch={loadSwitch}
                        driveData={driveData}
                      />
                    </TabPanel>
                    <TabPanel value={tabIndex} index={4}>
                      <TabProperties
                        propertyDetails={currentRow}
                        bedCount={"4 bed"}
                        currentRow={currentRow}
                        current={currentIndex}
                        currentUnit={currentUnit}
                        virtual={handleVirtual}
                        updateVirtualTourLink={updateVirtualTourLink}
                        localLink={localLink}
                        onData={handleDataFromChild}
                        loadSwitch={loadSwitch}
                        driveData={driveData}
                      />
                    </TabPanel>
                  </>
                )}
              </div>
            </div>
          </Drawer>
        </div>
        <Box
          sx={{ height: "80vh", width: "100%" }}
          onContextMenu={handleContextMenu}
          style={{ cursor: "context-menu" }}
        >
          {properties.length > 0 && (
            <DataGridPro
              initialState={{
                columns: {
                  columnVisibilityModel: {
                    months_fee_reference: false,
                    rent_concession_reference: false,
                    term_length: false,
                    months_fee: false,
                    rent_concession: false,
                    // application_fee: false,
                    // admin_fee: false,
                    google_place_name: false,
                    google_place_types: false,
                    google_rating: false,
                    google_place_id: false,
                    google_ratings_count: false,
                    google_operating_hours: false,
                    google_maps_url: false,
                    // number_floors: false,
                    created_at: false,
                    updated_at: false,
                    market: false,
                    lat: false,
                    lng: false,

                    studio: false,
                    one_bed: false,
                    two_bed: false,
                    three_bed: false,
                    four_plus_bed: false,

                    studio_price: false,
                    one_bed_price: false,
                    two_bed_price: false,
                    three_bed_price: false,
                    four_plus_bed_price: false,

                    one_and_a_half_bath: false,
                    concierge: false,
                    concrete_floors: false,
                    desk: false,
                    ev_charger: false,
                    fireplace: false,
                    floor_to_ceiling_windows: false,
                    // furnished: false,
                    garage: false,
                    high_ceilings: false,
                    industrial: false,
                    loft: false,
                    no_carpet: false,
                    roof_terrace: false,
                    single_family: false,
                    smart: false,
                    study: false,
                    terrace: false,
                    // townhome: false,
                    tub_shower: false,
                    // washer_dryer_connections: false,
                    // washer_dryer_in_building: false,
                    // washer_dryer_in_unit: false,
                    yard: false,
                  },
                },
                pinnedColumns: {
                  left: [
                    // "__check__",
                    // "actions",
                    "actions_copy_mail",
                    "black",
                    "id",
                    "name",
                    "star",
                    "apartment_url1",
                  ],
                },
              }}
              onCellDoubleClick={handleCellDoubleClick}
              rows={properties.map((property, index) => {
                let { ...rest } = property;
                delete rest.units;
                delete rest.models;
                delete rest.move_in_special;
                return {
                  id: property.id || index,
                  ...rest,
                };
              })}
              columns={generateColumns()}
              pageSize={paginationModel.pageSize}
              // checkboxSelection
              disableMultipleRowSelection
              components={{
                Toolbar: CustomToolbar,
              }}
              onCellClick={handleCellClick}
              // onRowSelectionModelChange={(newSelection) => {
              //   const selectedRowsData = properties.filter((row) =>
              //     newSelection.includes(row.id)
              //   );
              //   handleSelectionChange(newSelection);
              //   setSelectedRows(selectedRowsData);
              // }}
              experimentalFeatures={{ newEditingApi: true }}
              pagination
              paginationMode="server"
              paginationModel={paginationModel}
              onPaginationModelChange={(e) => {
                setPaginationModel((prev) => {
                  if (e.pageSize != prev?.pageSize) {
                    return {
                      page: 0,
                      pageSize: e.pageSize,
                    };
                  }
                  return e;
                });
              }}
              sortingMode="server"
              sortModel={sortModel}
              onSortModelChange={(model) => setSortModel(model)}
              rowCount={totalRows}
              loading={loading}
              getRowClassName={(params) => {
                const currentRowIndex =
                  properties.length > 0
                    ? properties.findIndex((row) => row.id === params.id)
                    : 0;
                return currentRowIndex % 2 === 0 ? "even-row" : "odd-row";
              }}
              {...properties}
            />
          )}
          <div className="custom-menuitem">
            {selectedRows.length > 0 && (
              <Menu
                open={contextMenu !== null}
                onClose={handleClose}
                anchorReference="anchorPosition"
                anchorPosition={
                  contextMenu !== null
                    ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                    : undefined
                }
              >
                <MenuItem
                  style={{
                    height: 31,
                  }}
                  onClick={() => handleCategoryChange("Change Category")}
                >
                  Change Category
                </MenuItem>

                {subMenuOpen &&
                  showCategory !== null &&
                  showCategory === "Change Category" && (
                    <Menu
                      open={subMenuOpen}
                      onClose={handleSubMenuClose}
                      anchorReference="anchorPosition"
                      anchorPosition={{
                        top: contextMenu.mouseY,
                        left: contextMenu.mouseX + 160,
                      }}
                    >
                      <MenuItem onClick={() => handleApplyCategory("null")}>
                        -
                      </MenuItem>
                      <MenuItem
                        onClick={() =>
                          handleApplyCategory("Not working with locators")
                        }
                      >
                        Not working with locators
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleApplyCategory("Student Housing")}
                      >
                        Student Housing
                      </MenuItem>
                      <MenuItem
                        onClick={() =>
                          handleApplyCategory("Affordable Housing")
                        }
                      >
                        Affordable Housing
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleApplyCategory("Do not add")}
                      >
                        Do not add
                      </MenuItem>
                      <MenuItem onClick={() => handleApplyCategory("Unsure")}>
                        Unsure
                      </MenuItem>
                    </Menu>
                  )}
              </Menu>
            )}
          </div>
        </Box>
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={1000}
          style={{ right: 0, top: "65px" }}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          onClose={handleCloseSnackbar}
          message="Copied to clipboard!"
          id="testing"
        />
        <Snackbar
          open={emailSnackbarOpen}
          autoHideDuration={1000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          style={{ right: 0, top: "65px" }}
          onClose={handleCloseEmailSnackbar}
          message="Copied to clipboard!"
        />
        {isPopupOpen && (
          <div className="popup">
            <Dialog open={isPopupOpen} onClose={handleClosePopup}>
              <DialogTitle className="flex flex-row justify-between">
                <>Edit Virtual Tour</>
                <IconButton onClick={handleAdd}>
                  <AddIcon style={{ color: "#0075FF" }} />
                </IconButton>
              </DialogTitle>
              <DialogContent>
                <div>
                  {tours.map((tour, propertyIndex) => (
                    <div
                      key={propertyIndex}
                      className="flex gap-10 "
                      style={{ margin: 16 }}
                    >
                      <TextField
                        name={`tours.${propertyIndex}.name`}
                        label={`Virtual Tour Name ${propertyIndex + 1}`}
                        value={tour?.name}
                        onChange={(e) =>
                          handleChange(
                            propertyIndex,
                            "name",
                            e.target.value.replace(/^\s+/, "")
                          )
                        }
                      />
                      <TextField
                        name={`tours.${propertyIndex}.link`}
                        label={`Virtual Tour Link ${propertyIndex + 1}`}
                        value={tour?.link}
                        onChange={(e) =>
                          handleChange(
                            propertyIndex,
                            "link",
                            e.target.value.replace(/^\s+/, "")
                          )
                        }
                      />

                      <IconButton onClick={() => handleRemove(propertyIndex)}>
                        <DeleteIcon style={{ color: "red" }} />
                      </IconButton>
                    </div>
                  ))}
                </div>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClosePopup}>Cancel</Button>
                <Button
                  onClick={handleSavePopup}
                  variant="contained"
                  color="primary"
                >
                  Save
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        )}
        <Modal
          open={isPopupDoubleClickOpen}
          onClose={handleCloseDoubleClick}
          aria-labelledby="popup-title"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              padding: 4,
              borderRadius: 1,
            }}
          >
            <Typography
              id="popup-title"
              variant="h6"
              component="h2"
              style={{ fontWeight: "bold", marginBottom: "10px" }}
            >
              Edit - {currentSelectedData?.row?.name} -{" "}
              {currentSelectedData?.colDef?.headerName}
            </Typography>
            <Typography variant="body1">
              <textarea
                rows={10}
                cols={80}
                onChange={(e) => {
                  setSelectedCellData(e.target.value);
                  setCurrentSelectedData((prevState) => ({
                    ...prevState,
                    row: {
                      ...prevState.row,
                      [currentSelectedData?.field]: e.target.value,
                    },
                  }));
                }}
              >
                {selectedCellData}
              </textarea>
            </Typography>
            <div
              style={{ display: "flex", justifyContent: "end", width: "100%" }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  handleRowUpdate(
                    currentSelectedData?.row,
                    {},
                    currentSelectedData?.field
                  );
                  setIsDoubleClickPopupOpen(false);
                }}
              >
                Submit
              </Button>
            </div>
          </Box>
        </Modal>
        <Modal
          open={deletePopup}
          onClose={handleDeletePopUp}
          aria-labelledby="popup-title"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              padding: 4,
              borderRadius: 1,
            }}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div style={{ fontSize: "20px" }}>
                Are you sure you want to delete the {currentProperty.name}{" "}
                property?
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  style={{ width: "20%", marginTop: "10px" }}
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={async () => {
                    setDeletePopup(false);
                    const response = await axiosInstance
                      .delete(
                        `${process.env.REACT_APP_API_URL}/deleteProperty/${currentProperty?.id}`
                      )
                      .then(async () => {
                        await fetchData();
                      });
                    setDeletePopup(false);
                  }}
                >
                  Yes
                </Button>
              </div>
            </div>
          </Box>
        </Modal>
        <SpecialCalculator
          calculator={calculator}
          setCalculator={setCalculator}
          messageApi={messageApi}
          contextHolder={contextHolder}
        />
        <Dialog open={openAmenitiesDialog} onClose={handleCloseDialog}>
          <DialogTitle>Amenities</DialogTitle>
          <DialogContent>
            <List>
              {amenityFields.map(({ key, label }) => (
                <ListItem key={key}>
                  <ListItemText primary={label} />
                  <ConfigProvider theme={antDTheme}>
                    <AntSwitch
                      size="small"
                      checked={!!selectedRowData?.[key]}
                         onChange={async (checked) => {
                        // 1️⃣ Update local modal data immediately
                        setSelectedRowData((prev) => ({
                          ...prev,
                          [key]: checked,
                        }));

                        // 2️⃣ Update filteredProperties list
                        setFilteredProperties((prev) =>
                          prev.map((property) =>
                            property.id === selectedRowData.id
                              ? { ...property, [key]: checked }
                              : property
                          )
                        );
                         // 3️⃣ Update in DB
                        try {
                          await axiosInstance.put(
                            `${process.env.REACT_APP_API_URL}/property/${selectedRowData.id}?sort=false`,
                            {
                              data: { [key]: checked },
                            }
                          );
                          console.log(
                            `✅ Property ${selectedRowData.id} updated successfully`
                          );
                        } catch (error) {
                          console.error("❌ Failed to update property:", error);
                        }
                      }}
                    />
                  </ConfigProvider>
                </ListItem>
              ))}
            </List>
          </DialogContent>
        </Dialog>
        <Dialog open={openBedroomDialog} onClose={handleCloseDialog}>
          <DialogTitle>Bedrooms</DialogTitle>
          <DialogContent>
            <List>
              {bedroomFields.map(({ key, label, priceKey }) => (
                <ListItem key={key}>
                  <ConfigProvider theme={antDTheme}>
                    <AntSwitch
                      size="small"
                      checked={!!selectedRowData?.[key]}
                      onChange={async (checked) => {
                        // 1️⃣ Update local modal data immediately
                        setSelectedRowData((prev) => ({
                          ...prev,
                          [key]: checked,
                        }));

                        // 2️⃣ Update filteredProperties list
                        setFilteredProperties((prev) =>
                          prev.map((property) =>
                            property.id === selectedRowData.id
                              ? { ...property, [key]: checked }
                              : property
                          )
                        );
                         // 3️⃣ Update in DB
                        try {
                          await axiosInstance.put(
                            `${process.env.REACT_APP_API_URL}/property/${selectedRowData.id}?sort=false`,
                            {
                              data: { [key]: checked },
                            }
                          );
                          console.log(
                            `✅ Property ${selectedRowData.id} updated successfully`
                          );
                        } catch (error) {
                          console.error("❌ Failed to update property:", error);
                        }
                      }}
                    />
                  </ConfigProvider>
                  <ListItemText
                    primary={label}
                    secondary={`Price: $${selectedRowData?.[priceKey] || "-"}`}
                    sx={{ marginLeft: 2 }}
                  />
                </ListItem>
              ))}
            </List>
          </DialogContent>
        </Dialog>
        {contextHolder}
      </div>
    </div>
  );
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default AllProperties;
